import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Layout from './Layout';

const ProtectedRoute = () => {
  const { isAuthenticated, isLoading, profileRequestSent } = useAuth();
  const location = useLocation();
  // トークンの有無を確認（プロファイル取得前に一時的にログイン判定を保留するため）
  const tokens = localStorage.getItem('tokens');

  // トークンが存在し、プロファイル取得が完了していない場合はローディング画面を表示
  if (tokens && !profileRequestSent) {
    return (
      <Layout>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
          <h2>ログイン状態を確認中...</h2>
        </div>
      </Layout>
    );
  }
  // プロファイル取得やログイン処理などでローディング中はローディング画面を表示
  if (isLoading) {
    return (
      <Layout>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
          <h2>ログイン状態を確認中...</h2>
        </div>
      </Layout>
    );
  }

  // 認証されていない場合はログインページにリダイレクト（現在のURLをstate経由で保存）
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 認証済みの場合は子ルートをレンダリング
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default ProtectedRoute; 